import React, { useState } from 'react';
import ShareModal from "./ShareModal";

const ShareButton = ({ eventId, eventTitle }) => {
  const [showModal, setShowModal] = useState(false);
  const eventUrl = `https://fusshn.com/event/${eventId}`; // Replace with your domain

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="text-white bg-gray-700 px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors duration-300"
      >
        Share
      </button>

      {showModal && (
        <ShareModal
          eventUrl={eventUrl}
          eventTitle={eventTitle}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ShareButton;
